// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"e9c37eda","200":"95b8df38","229":"c0e8654a","239":"b7c93cfe","283":"2ad84d36","454":"2a6abfce","467":"2fb075a7","859":"5cebff74","954":"c0292a0f","965":"b47e1264"}[chunkId] + ".chunk.js";
};